import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import { ErrorHandler } from '@playbookux/playbook-web-core';

import {
  Button,
  ButtonArea,
  Container,
  Content,
  Dialog,
  Radio,
  RadioContainer,
  Text,
} from './styles';

const ChangeStatusModal = (props) => {
  const {
    error,
    loading,
    onClick,
    onClose,
    onSubmit,
    options,
    show,
  } = props;

  return (
    <Container
      active={show}
      onClickOutside={onClose}
      page
    >
      <Dialog>
        <Text.Bold>Status</Text.Bold>

        <Content>
          {_.map(options, (option) => (
            <RadioContainer key={option.key}>
              <Radio
                value={option.key}
                onClick={() => onClick(option.key)}
                checked={option.checked}
              />

              <Text
                fontSize="14px"
                onClick={() => onClick(option.key)}
              >
                {option.text}
              </Text>
            </RadioContainer>
          ))}
        </Content>

        {error && (
          <ErrorHandler
            error={error}
            defaultMessage="Error while saving."
          />
        )}

        <ButtonArea>
          <Button
            onClick={onSubmit}
            disabled={loading}
            loading={loading}
          >
            Save
          </Button>
        </ButtonArea>
      </Dialog>
    </Container>
  );
};

ChangeStatusModal.propTypes = {
  error: PropTypes.PropTypes.shape({
    message: PropTypes.string,
  }),
  loading: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  options: PropTypes.shape({
    checked: PropTypes.bool.isRequired,
    key: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }).isRequired,
  show: PropTypes.bool,
};

ChangeStatusModal.defaultProps = {
  error: null,
  loading: false,
  show: false,
};

export default ChangeStatusModal;
